module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style10/message-alert-style10.component.scss
// module id = ./src/app/features/message-alert/message-alert-style10/message-alert-style10.component.scss
// module chunks = main